"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AgendaItemMeeting () {
        return AgendaItemMeeting;
    },
    get AgendaItemModel () {
        return AgendaItemModel;
    },
    get CreateMeetingAgendaItemServiceActionSchema () {
        return CreateMeetingAgendaItemServiceActionSchema;
    },
    get UpdateMeetingAgendaItemServiceActionSchema () {
        return UpdateMeetingAgendaItemServiceActionSchema;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("./base");
const AgendaItemMeeting = _zod.z.object({
    meetingId: _utilsisomorphic.transformObjectId,
    status: _models.MeetingAgendaItemStatusSchema
});
const AgendaItemModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    meetings: _zod.z.array(AgendaItemMeeting),
    goalId: _utilsisomorphic.transformObjectId.nullable().optional(),
    created: _base.UserActionRecord,
    updated: _base.UserActionRecord
});
const CreateMeetingAgendaItemServiceActionSchema = _models.MeetingAgendaItemsSchema.pick({
    name: true,
    meetings: true,
    goal_id: true
});
const UpdateMeetingAgendaItemServiceActionSchema = _models.MeetingAgendaItemsSchema.pick({
    name: true,
    meetings: true,
    goal_id: true,
    updated: true
}).partial();
